import React from "react";
import API from "../../services/api.jsx";
import Loader from "../layout/loader.jsx";
import Head from "../layout/head.jsx";
import Content from "../layout/content.jsx";
import Table from "../layout/table.jsx";
import moment from "moment";
import { toast } from "react-toastify";
import SmartPlayTag from "../layout/SmartPlayTag/index.jsx";
import Helpers from "../../services/helpers.jsx";

class CollectionCampaignsList extends React.Component {
  constructor(props) {
    super(props);

    const params = this.props.match.params;
    const tabsLinks = [];
    if (Helpers.checkPermissions("collections:details")) {
      tabsLinks.push({
        title: "Details",
        path: params.clientId
          ? `/clients/${params.clientId}/collections/${params.collectionId}`
          : `/assets/collections/${params.collectionId}`,
      });
    }
    if (Helpers.checkPermissions("campaigns:list")) {
      tabsLinks.push({
        title: "Campaigns",
        path: params.clientId
          ? `/clients/${params.clientId}/collections/${params.collectionId}/campaigns`
          : `/assets/collections/${params.collectionId}/campaigns`,
      });
    }

    this.state = {
      clients: [],
      sort: ["name", "ASC"],
      tabs: {
        links: tabsLinks,
      },
      breadcrumb: { title: "Back to collections", path: "/assets/collections" },
      clientIndex: [],
      selectedClient: params?.clientId ?? null,
      loading: true,
      campaigns: {
        columns: [
          {
            label: "Campaign name",
            key: "name",
            canSort: true,
            onSortClick: (column) => this.onSort(column.key),
            view: (field, entity) => {
              return (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div>{field}</div>
                  {entity?.hasSmartPlay && <SmartPlayTag marginLeft={6} />}
                </div>
              );
            },
          },
          {
            label: "Client",
            key: "client",
            view: (field) => {
              console.log(this.clientIndex);
              console.log(field, this.state.clientIndex.indexOf(field));
              if (this.state.clientIndex.indexOf(field) !== -1) {
                return this.state.clients[this.state.clientIndex.indexOf(field)]
                  .name;
              }
              return "???";
            },
          },
          {
            label: "Duration",
            key: "infinite",
            view: (field, entity) => {
              return field === true
                ? "Infinite"
                : moment(entity.startDate).format("L") +
                    " - " +
                    moment(entity.endDate).format("L");
            },
          },
          {
            label: "Status",
            key: "status",
            view: (field) => {
              return (
                <div
                  style={{
                    color: Helpers.CAMPAIGN_STATUS_MAP[field]?.labelColor,
                  }}
                >
                  {Helpers.CAMPAIGN_STATUS_MAP[field]?.label}
                </div>
              );
            },
            canSort: true,
            onSortClick: (column) => this.onSort(column.key),
          },
          {
            label: "Devices",
            key: "devices",
            view: function (field) {
              return field;
            },
          },
          {
            label: "Priority",
            key: "priority",
            canSort: true,
            onSortClick: (column) => this.onSort(column.key),
          },
          {
            label: "Last update",
            key: "lastUpdatedAt",
            view: function (field) {
              if (field) {
                return moment(field).format("l");
              }
              return "-";
            },
            canSort: true,
            onSortClick: (column) => this.onSort(column.key),
          },
          {
            label: "Update by",
            key: "nextUpdateBy",
            view: function (field) {
              if (field) {
                const value = moment(field).format("l");
                const passed = moment(field).isSameOrBefore(moment());
                return passed ? <div className="red">{value}</div> : value;
              }
              return "-";
            },
            canSort: true,
            onSortClick: (column) => this.onSort(column.key),
          },
        ],
        entities: [],
        filters: [],
        actions: [],
        selectedItems: [],
        multiSelect: false,
        onRowClick: (entity) => {
          if (
            Helpers.checkPermissions(
              ["campaigns:details", "campaigns:edit"],
              true
            )
          ) {
            this.props.history.push("/campaigns/" + entity.id);
          }
        },
      },
    };
  }

  async componentDidMount() {
    this.loadEntities();
  }

  onSort(key) {
    const newSort =
      this.state?.sort?.[0] === key
        ? this.state?.sort?.[1] === "ASC"
          ? [key, "DESC"]
          : [key, "ASC"]
        : [key, "ASC"];
    this.setState(
      {
        sort: newSort,
      },
      () => {
        this.loadEntities();
      }
    );
  }

  loadEntities() {
    const id = this.props.match.params.collectionId;
    API.getCollection(id).then(async (collection) => {
      const clientsRaw = await API.getClients();
      const clients = clientsRaw?.data || [];
      const clientIndex = clients.map((client) => client.id);
      const selectedClient = this.state.selectedClient ?? this.props.match?.params?.clientId ?? null;
      const entities =
        selectedClient && clientIndex.indexOf(selectedClient) !== -1
          ? (await API.getCampaignsForClientCollection(id, selectedClient, this.state.sort)) || []
          : (await API.getCampaignsForCollection(id, this.state.sort)) || [];
      this.setState({
        ...this.state,
        collection,
        clients,
        clientIndex,
        campaigns: { ...this.state.campaigns, entities },
        loading: false,
      });
    });
  }

  playlistCover() {
    return (
      <div
        className="playlist-cover"
        style={{
          backgroundImage:
            "url(" +
            API.apiURL +
            "/storage/collection-cover/" +
            (this.state.collection.cover && this.state.collection.cover.uri) +
            ")",
        }}
        onClick={(e) => {
          this.uploadCover.click();
        }}
      ></div>
    );
  }

  onChangeCoverFile(event) {
    event.stopPropagation();
    event.preventDefault();

    // Check if there are files to upload
    if (event.target.files.length < 1) return;

    // @todo, check all files extentions

    // Display loader
    this.setState({ loading: true });

    API.postCollectionCover(event.target.files[0]).then((file) => {
      let collection = JSON.parse(JSON.stringify(this.state.collection));
      if (!collection.playlists) collection.playlists = [];
      collection.cover = file.cover;
      collection.coverHash = file.coverHash;
      collection.playlists = collection.playlists.map(
        (playlist) => playlist.id
      );
      this.setState({
        showPopup: false,
        loading: true,
      });
      API.update("collections", this.state.collection.id, collection).then(
        (collection) => {
          this.setState({
            selectedPlaylist: null,
            collection: collection,
            playlists: {
              ...this.state.playlists,
              entities: collection.playlists,
            },
            loading: false,
          });
          toast.success("Collection updated");
        }
      );
    });
  }

  render() {
    if (this.state.loading) return <Loader />;
    else
      return (
        <>
          <Head
            tabs={this.state.tabs}
            title={this.state.collection.name}
            beforeTitle={this.playlistCover.bind(this)}
            breadcrumb={this.state.breadcrumb}
            edit={() => {
              if (Helpers.checkPermissions("collections:edit")) {
                this.props.history.push(
                  "/assets/collections/" +
                    this.props.match.params.collectionId +
                    "/edit"
                );
              }
            }}
          />
          <Content>
            {this.state.loading === true ? (
              <Loader />
            ) : (
              <>
                <input
                  type="file"
                  ref={(ref) => (this.uploadCover = ref)}
                  style={{ display: "none" }}
                  onChange={this.onChangeCoverFile.bind(this)}
                  value={this.state.selectedCoverFile}
                  accept=".jpg,.png,.jpeg"
                />
                <Table settings={this.state.campaigns} sort={this.state.sort} />
              </>
            )}
          </Content>
        </>
      );
  }
}

export default CollectionCampaignsList;
